export class DocumentoSpesaVO {
  importo: string;
  importoNetto: string;
  cig: string;
  cup: string;
  pad: string;
  lineaFinanziamento: string;
  scadenzaDurc: string;
  iva: number;
  splitPayment: boolean;
}
